module.exports = __webpack_public_path__ + "static/media/1@3x.3dfe0e63.png";